<template>
    <div>
        <div class="col-md-12">
            <b-form class="form-inline mt-3">
                <b-form-datepicker  class="mb-2 mr-sm-2 mb-sm-0" v-model="startDate" ></b-form-datepicker>
                <b-form-datepicker  class="mb-2 mr-sm-2 mb-sm-0" v-model="endDate" ></b-form-datepicker>

                <b-form-radio-group
                        class="ml-auto mr-3"
                        v-model="period"
                        :options="periodOptions"
                        buttons
                        name="radios-btn-default">
                </b-form-radio-group>

                <b-btn @click="getEarnings" class="btn btn-info mb-2 mr-sm-2 mb-sm-0">Search</b-btn>
            </b-form>
        </div>

        <loader v-if="loading"></loader>
        <b-table v-else striped hover class="mt-3" :items="earnings"></b-table>

    </div>
</template>

<script>
    import GetDriverEarning from "../../../../../store/actions/getDriverEarning";
    import ContentLoader from "../../../../../components/ContentLoader";
    import ShowError from "../../../../../helpers/showError";

    const today = new Date();
    export default {
        name: 'DriverEarningComponent',
        components: {
            loader: ContentLoader,
        },
        data: () => ({
            loading: false,
            startDate: new Date(today.getFullYear(), today.getMonth(), 1),
            endDate: today,
            period: 'day',
            periodOptions: [
                {text: 'Daily', value: 'day'},
                {text: 'Weekly', value: 'week'},
                {text: 'Monthly', value: 'month'},
            ],
            earnings: []
        }),
        created() {
            this.getEarnings();
        },
        methods: {
            async getEarnings() {
                try{
                    this.loading = true;
                    const earnings = await GetDriverEarning({
                        userId: this.$route.params.id,
                        startDate: this.startDate,
                        endDate: this.endDate,
                        period: this.period
                    });

                    this.earnings = earnings.map(earning => {
                        earning.period = new Date(earning.period).toLocaleDateString();
                        earning.total = `₺ ${earning.total}`
                        return earning;
                    })
                }
                catch (e) {
                    ShowError(this, e);
                }
                finally {
                    this.loading = false;
                }
            }
        }
    }
</script>